module.exports = __webpack_public_path__ + "img/Facebook.ae9ad5d1.svg";